import { render, staticRenderFns } from "./ChatUserCard.vue?vue&type=template&id=1f097cea&scoped=true"
import script from "./ChatUserCard.vue?vue&type=script&lang=js"
export * from "./ChatUserCard.vue?vue&type=script&lang=js"
import style0 from "./ChatUserCard.vue?vue&type=style&index=0&id=1f097cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f097cea",
  null
  
)

export default component.exports